const lang = {
    locale: "zh-TW",
    cancel: '取消',
    close: '關閉',
    ok: '確定',
    country: {
        china: '中國',
        hongKong: '中國香港',
        macau: '中國澳門',
        taiwan: '中國臺灣',
        singapore: '新加坡',
        malaysia: '馬來西亞',
        indonesia: '印度尼西亞',
        thailand: '泰國',
        philippines: '菲律賓',
        vietnam: '越南',
        myanmar: '緬甸'
    },
    friendlyTime: {
        just: '剛剛',
        yesterday: '昨天',
        oneMinuteAgo: '1分鐘前',
        minutesAgo: '分鐘前',
        oneHourAgo: '1小時前',
        hoursAgo: '小時前',
        daysAgo: '天前',
        weeksAgo: '週前',
    },
    enterTheContent: '請輸入內容',
    multilingual: '多語',
    loading: '加載中…',
    select: '請選擇',
    page: {
        loadMore: '加載更多',
        loading: '正在加載',
        noMore: '沒有更多數據了'
    },
    empty: {
        data: '暫無數據',
        search: '搜索無結果',
        develop: '正在建設中、正在努力維護中',
        network: '暫無網絡',
        server: '服務器出錯了',
        404: '404',
        approve: '認證、審核請耐心等待'
    },
    pagination: {
        total: "共",
        item: "條",
        items: "條",
        page: "條/頁",
        goto: "跳至",
        pageItem: "頁"
    },
    selectMember: {
        all: '全部',
        title: '選擇人員',
        titleRange: '選擇範圍',
        selected: '已選擇',
        search: '搜索',
        clear: '清空',
        cancel: '取消',
        ok: '確定',
        dept: '組織',
        recentMember: '最近聯係人',
        deptMember: '組織成員',
        group: '內部群',
        groupMember: '內部群成員',
        team: '組',
        teamMember: '組內成員',
        member: '成員',
        role: '角色',
        roleMember: '角色成員',
        external: '外部人員',
        other: '其他',
        includingSubordinate: '包含下級',
        cancelSubordinate: '取消下級',
        includingSubordinateOrg: '包含下級組織',
        cancelSubordinateOrg: '取消下級組織',
        publicTeam: '公共組',
        privateTeam: '個人組',
        maximum: '已超出最大限制',
        enterKeywordToSearch: '輸入關鍵字搜索',
        external: '外部',
        externalMember: '外部人員',
    },
    datepicker: {
        selectDate: "選擇日期",
        selectTime: "選擇時間",
        startTime: "開始時間",
        endTime: "結束時間",
        clear: "清空",
        ok: "確定",
        datePanelLabel: "[yyyy年] [m月]",
        month: "月",
        month1: "1 月",
        month2: "2 月",
        month3: "3 月",
        month4: "4 月",
        month5: "5 月",
        month6: "6 月",
        month7: "7 月",
        month8: "8 月",
        month9: "9 月",
        month10: "10 月",
        month11: "11 月",
        month12: "12 月",
        year: "年",
        weekStartDay: "0",
        weeks: {
            sun: "日",
            mon: "一",
            tue: "二",
            wed: "三",
            thu: "四",
            fri: "五",
            sat: "六"
        },
        months: {
            m1: "1月",
            m2: "2月",
            m3: "3月",
            m4: "4月",
            m5: "5月",
            m6: "6月",
            m7: "7月",
            m8: "8月",
            m9: "9月",
            m10: "10月",
            m11: "11月",
            m12: "12月"
        }
    },
    table: {
        noDataText: "暫無資料",
        noFilteredDataText: "暫無篩選結果",
        confirmFilter: "篩選",
        resetFilter: "重置",
        clearFilter: "全部"
    },
    upload: {
        file: '附件',
        addFile: '添加附件',
        download: '下載',
        upload: '上傳',
        secretLevel: '密級',
        dragFilesHereToUpload: '拖動文件到此上傳',
        batchDownload: '批量下載',
        preview: '預覽',
        singleMaxSize: '單個附件最多s1%M',
        allowDownload: '允許下載',
        fileUploading: '上傳附件',
        public: '公開',
        internal: '内部',
        secret: '秘密',
        confidential: '機密',
        pleaseSelectFileSecretLevel: '請選擇附件密級',
        fileUploadFailed: '附件上傳失敗',
        fileExceedsSizeLimit: '附件超過單附件大小限制',
        emptyFileIsNotAllowedToUpload: '禁止上傳空文件',
        upToCountFilesCanBeUploaded: '最多可以上傳s1%個文件',
        pleaseSelectFile: '請選擇附件',
        noFiles: '暫無附件',
        delete: '删除',
        deleteSucceeded: '删除成功',
        deleteFailed: '删除失敗',
        noAuthorization: '無權操作'
    }
}

export default lang